import { useState } from "react";
import fetch from "isomorphic-unfetch";

//COMPONENTS
import { Input } from "./Input";

const ContactForm = () => {
  const [form, setForm] = useState({
    fullname: "",
    company: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const createContactMessage = async () => {
    try {
      const res = await fetch("/send", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });
      setForm({
        fullname: "",
        company: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.log(error);
    }
  };

  const validate = () => {
    let err = {};

    if (!form.fullname) {
      err.firstname = "A name is required";
    }
    if (!form.company) {
      err.company = "A company is required";
    }
    if (!form.email) {
      err.email = "An email address is required";
    }
    if (!form.message) {
      err.message = "A message is required";
    }

    return err;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let errs = validate();
    if (Object.keys(errors).length > 0) {
      setErrors(errs);
    } else {
      createContactMessage();
      setIsSubmitted(true);
    }
    console.log("Message submitted");
  };

  const inputContent = [
    {
      label: "Full name",
      type: "text",
      name: "fullname",
      id: "fullname",
      autoComplete: "name",
      placeholder: "Full name",
    },
    {
      label: "Email",
      type: "email",
      name: "email",
      id: "email",
      autoComplete: "email",
      placeholder: "Email",
    },
    {
      label: "Company",
      type: "text",
      name: "company",
      id: "company",
      autoComplete: "name",
      placeholder: "Company",
    },
  ];

  return (
    <div className="sm:px-6 lg:col-span-3 lg:pt-20 lg:px-8 xl:pl-12">
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-y-6">
        {isSubmitted && (
          <div className="mt-4 text-lg leading-6 text-white">
            Your message has been submitted.
          </div>
        )}
        {inputContent.map((item) => (
          <Input
            key={item.id}
            label={item.label}
            type={item.type}
            name={item.name}
            id={item.id}
            autoComplete={item.autoComplete}
            placeholder={item.placeholder}
            value={form[item.name]}
            onChange={handleChange}
          />
        ))}
        <div>
          <label htmlFor="message" className="sr-only">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            rows={4}
            className="block w-full shadow-sm py-3 px-4 focus:opacity-100 focus:ring-yellow focus:border-yellow rounded-md placeholder-lightGrey text-white"
            placeholder="Message"
            onChange={handleChange}
            value={form.message}
            error={
              errors.message
                ? { content: "Please enter a message", pointing: "below" }
                : null
            }
            style={{ backgroundColor: "#B24E2F" }}
          />
        </div>
        <div>
          <button
            type="submit"
            className="w-full bg-white rounded-md shadow-md py-4 whitespace-nowrap text-xl font-medium text-earth"
          >
            Submit
          </button>
        </div>
        <br />
      </form>
    </div>
  );
};

export default ContactForm;
